import { cn as e } from "../shared/utils.js";
import { cva as t } from "class-variance-authority";
//#region src/menu/menu.styles.ts
var n = t(e("flex w-full min-w-0 cursor-pointer items-center outline-none", "transition-base transition-[background-color,color]", "hover:bg-bg-tertiary data-highlighted:bg-bg-tertiary", "data-disabled:text-text-disabled data-disabled:[&_svg]:text-icon-disabled data-disabled:pointer-events-none data-disabled:cursor-not-allowed", "[&_[data-hint-trigger]]:pointer-events-auto", "focus-visible:focus-ring-primary"), {
	defaultVariants: {
		size: "md",
		state: "default",
		surface: "popup"
	},
	variants: {
		size: {
			md: "min-h-9 py-3 [&_svg]:size-5 text-base",
			sm: "min-h-8 py-3 [&_svg]:size-4 text-sm"
		},
		state: {
			active: "text-text-link [&_svg]:text-icon-accent",
			default: "text-text-primary [&_svg]:text-icon-primary",
			destructive: "text-text-error [&_svg]:text-icon-error"
		},
		surface: {
			drawer: "px-3",
			popup: "px-4"
		}
	}
}), r = t(e("border-border-100 bg-bg-primary shadow-1 flex max-h-(--available-height) min-w-30 flex-col overflow-y-auto rounded-md border py-1 outline-none", "transition-base origin-(--transform-origin) transition-[opacity,transform]", "data-starting-style:-translate-y-px data-starting-style:opacity-0", "data-ending-style:opacity-0 data-ending-style:duration-150 data-ending-style:ease-in")), i = t("bg-border-100 h-px w-full shrink-0");
//#endregion
export { n as menuItemVariants, r as menuPopupVariants, i as menuSeparatorVariants };
